import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
	text: {
		overflow: 'auto',
		textAlign: 'left',
	},
});
